import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import validator from 'validator';
import { Trans, t } from '@lingui/macro';
import { I18n } from '@lingui/react';
import i18nInstance from '@moka-bo/i18n';
import styles from './style.css';
import ResetPasswordField from '../Fields/ResetPasswordField/ResetPasswordField';

const validate = values => {
  const errors = {};
  if (!values.email) {
    errors.email = i18nInstance._(t`The email address is required`);
  } else if (!validator.isEmail(values.email)) {
    errors.email = i18nInstance._(t`The value is not a valid email address`);
  }
  return errors;
};

const ResetPasswordFormInvalid = class ResetPasswordFormInvalid extends React.Component {
  render() {
    return (
      <div className="col-md-12 no-padding">
        <form onSubmit={this.props.handleSubmit}>
          <p className={`text-center ${styles['description-reset-password']}`}>
            <Trans>
              The link provided is already expired or no longer match, please
              resubmit your email and try again.
            </Trans>
          </p>

          <I18n>
            {({ i18n }) => (
              <Field
                component={ResetPasswordField}
                name="email"
                maxLength="40"
                autoCorrect="off"
                autoCapitalize="off"
                placeholder={i18n._(t`Registered email address`)}
                spellCheck="false"
              />
            )}
          </I18n>

          <div className={styles['submit-btn-container']}>
            <button
              type="submit"
              className={`btn btn-primary ${styles['submit-btn']}`}
            >
              {this.props.btnText}
            </button>
          </div>
        </form>
        <div
          className={`col-md-12 col-xs-12 text-center ${
            styles['back-to-login']
          }`}
        >
          <Link to="/login" className="text-center">
            <Trans>Back to login</Trans>
          </Link>
        </div>
      </div>
    );
  }
};

ResetPasswordFormInvalid.propTypes = {
  dispatch: PropTypes.func,
  onSubmit: PropTypes.func,
  btnText: PropTypes.string,
};

const mapFormValidation = {
  form: 'ResetPasswordFormInvalid',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

export default reduxForm(mapFormValidation)(ResetPasswordFormInvalid);
